angular.module("vgresiduos").directive("disposalEstimateGathering", function () {
	return {
		scope: true,
		controller: "DisposalEstimateGatheringCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalEstimateGathering/disposalEstimateGathering_template.html"
	};
});
